import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, XCircle } from "lucide-react";
import PageShell from "../components/sections/PageShell";

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function CheckoutCancelPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Checkout canceled — Gadget Guy Media";
    setLink("canonical", "https://gadgetguymedia.com/checkout/cancel");
  }, []);

  return (
    <PageShell testId="checkout-cancel-page">
      <section
        className="relative"
        style={{ paddingTop: "clamp(48px, 12vh, 128px)", paddingBottom: "clamp(48px, 8vh, 96px)" }}
      >
        <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
          <XCircle
            size={72}
            className="text-white/40 mx-auto"
            data-testid="checkout-cancel-icon"
          />
          <h1
            className="mt-6 font-condensed uppercase text-white"
            style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)", letterSpacing: "-0.015em" }}
            data-testid="checkout-cancel-heading"
          >
            Checkout canceled.
          </h1>
          <p
            className="mt-5 font-body text-white/75 text-base md:text-lg leading-relaxed"
            data-testid="checkout-cancel-copy"
          >
            No worries — no charge was made. Pick things back up whenever you're ready.
          </p>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/pricing" className="ggm-btn-primary" data-testid="checkout-cancel-cta-pricing">
              Back to pricing <ArrowRight size={16} />
            </Link>
            <Link to="/" className="ggm-btn-secondary" data-testid="checkout-cancel-cta-home">
              Back home <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
